import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { walletApi } from '../../api/walletApi'

interface WalletState {
  balance: number | null  // in paise
  loading: boolean
  error: string | null
}

const initialState: WalletState = {
  balance: null,
  loading: false,
  error: null,
}

export const fetchBalance = createAsyncThunk('wallet/fetchBalance', async (_, { rejectWithValue }) => {
  try {
    const response = await walletApi.getBalance()
    return response.data.data!.balancePaise
  } catch (err: unknown) {
    const error = err as { response?: { data?: { message?: string } } }
    return rejectWithValue(error.response?.data?.message ?? 'Failed to fetch balance')
  }
})

const walletSlice = createSlice({
  name: 'wallet',
  initialState,
  reducers: {
    setBalance: (state, action) => {
      state.balance = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBalance.pending, (state) => { state.loading = true })
      .addCase(fetchBalance.fulfilled, (state, action) => {
        state.loading = false
        state.balance = action.payload
      })
      .addCase(fetchBalance.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export const { setBalance } = walletSlice.actions
export default walletSlice.reducer
